import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import { Form, Formik, Field } from "formik";
import HOCButton from "web/components/Button";
import NumberInput from "web/components/form-elements/NumberInput";
import TextArea from "web/components/form-elements/TextArea";
import RadioButton from "web/components/form-elements/RadioButton";
import DatePicker from 'web/components/form-elements/DatePicker';
import Spinner from '../../../../components/Spinner'
import { adminClaimFeeCalculate } from '../../../../../redux/actions/admin';
import AlertModal from 'web/components/AlertModal';
import { Tooltip } from "reactstrap";
import information from "web/assets/images/informationIcon.png";
import {
    ClaimInfoSection,
    ResolutionModalInnerBoxes,
    AdjustRefundSection,
    SubmitButtonWrapper,
    SummarySection
} from "./ClaimStyled";
import CloseIcon from "web/assets/images/CloseIcon.png";

function AdjustmentModal(props) {
    let dispatch = useDispatch()
    let history = useHistory()
    let selectedOrderDetails = props.selectedOrderDetails
    let refundProcessType = props.refundProcessType
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible)
    const [summaryInfoValues, setSummaryInfoValues] = useState()
    const [modal, setModal] = useState(false)
    const [modalContent, setModalContent] = useState('')

    const [tooltip, setTooltip] = useState(false)
    const [tooltipSection, settTooltipSection] = useState("")

    const adjustmentRadioOptions = [
        { value: 'refundBuyer', label: 'Refund to Buyer', tooltip: "REFUND TO BUYER: This adjustment will TAKE BACK funds from the seller and REFUND the buyer." },
        { value: 'chargeBuyer', label: 'Charge the Buyer', tooltip: "CHARGE THE BUYER: This adjustment will CHARGE the buyer and PAY the seller." },
    ];

    const INITIAL_VALUES = {
        adjustmentOptions: 'refundBuyer',
        ammendedQuantity: '',
        comments: '',
        taxAmount: selectedOrderDetails.buyerInfo?.price?.tax?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    };

    const VALIDATION_SCHEMA = Yup.object().shape({
    });

    const toggle = () => {
        props.toggle();
    };

    // for calculating the remaining quanity in case claim raised scenarios
    let actualDisplayQuantity = selectedOrderDetails?.orderDetails?.quantity
    let totalClaimQuantity = 0
    if (selectedOrderDetails?.claimDetails?.length > 0) {
        totalClaimQuantity = selectedOrderDetails?.claimDetails.reduce((acc, value) => {
            return acc + value.claimQuality + value.claimQuantity
        }, 0)
    }
    actualDisplayQuantity = actualDisplayQuantity - totalClaimQuantity

    const calcualteFunction = async (value) => {
        let response = '';
        let data = { orderId: selectedOrderDetails.orderId, adjustmentAmount: value }
        response = await dispatch(adminClaimFeeCalculate(data));
        if (response.status === 'SUCCESS') {
            setSummaryInfoValues(response.payload)
        } else {
            if (response.statusCode === 401) {
                history.push('./sign-in')
                window.location.reload(false);
            }
        }
    }

    const adminRefundInitiateFunction = propsVal => {
        let data = propsVal.values
        data.adjustmnetValues = summaryInfoValues
        if (propsVal.values.adjustmentOptions === 'refundBuyer' && propsVal.values.ammendedQuantity > actualDisplayQuantity) {
            setModalContent('To refund the buyer, the adjusted quantity should not be greater than the ordered quantity')
            setModal(!modal)
        } else if (propsVal.values.comments?.length < 10) {
            setModalContent('Comment should have atleast 10 characters.')
            setModal(!modal)
        } else props.refundClaimFunctionCallBack(data)
    }

    const adminRefundTaxInitiateFunction = propsVal => {
        let data = propsVal.values
        if (propsVal.values.comments?.length < 10) {
            setModalContent('Comment should have atleast 10 characters.')
            setModal(!modal)
        } else props.refundClaimFunctionCallBack(data)
    }

    const showToolTip = (infoSection, infoTxt) => {
        return (
            <>
                <img
                    id={infoSection}
                    src={information}
                    style={{ position: "relative", top: "-1px", marginLeft: "6px", }}
                />
                <Tooltip
                    placement="right"
                    isOpen={tooltip && tooltipSection === infoSection}
                    target={infoSection}
                    toggle={() => {
                        setTooltip(!tooltip);
                        settTooltipSection(tooltipSection === "" ? infoSection : "");
                    }}
                >
                    {infoTxt}
                </Tooltip>
            </>
        );
    };

    return (
        <>
            <Formik
                initialValues={INITIAL_VALUES}
                validationSchema={VALIDATION_SCHEMA}
                onSubmit={(values) => { }}
            >
                {(props) => {
                    const { isValid, dirty, values, errors, touched, setFieldValue } = props;
                    return (
                        <div className={refundProcessType === "adjustmentPTOveride" && "red-outline"}>
                            <Form>
                                {loaderVisible && <Spinner />}
                                <ResolutionModalInnerBoxes>
                                    <div className={"exchange-modal-header"}>
                                        <h1>{refundProcessType === 'adjustmentPTOveride' ? 'Payment Adjustment - PT Override' :
                                            refundProcessType === 'adjustmentModal' ? 'Payment Adjustment' : 'Refund Tax Amount'}</h1>
                                        <img src={CloseIcon} alt="close-icon" onClick={toggle} />
                                    </div>
                                </ResolutionModalInnerBoxes>

                                {refundProcessType === 'adjustmentPTOveride' &&
                                    <div>
                                        <p style={{ margin: '7px 0px 0px 10px' }}>
                                            The Amount will be settled through Our PalletTrader account and Need to be approve by the super Admin only.
                                        </p>
                                    </div>
                                }

                                <>
                                    <ClaimInfoSection>
                                        <div className=" mx-2 my-2 claim-info-section">
                                            <h6>Order Details</h6>
                                            <div className="claim-info">
                                                <div>
                                                    <p>Order Type</p>
                                                    <p>{selectedOrderDetails.type === 'PICKUP' ? 'Pick Up' : 'Delivery'}</p>
                                                </div>
                                                <div>
                                                    <p>Total Quantity</p>
                                                    <p>{actualDisplayQuantity}</p>
                                                </div>
                                                <div>
                                                    <p>Base Cost</p>
                                                    <p>${selectedOrderDetails.orderDetails?.pricePerPallet?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </ClaimInfoSection>
                                    <AdjustRefundSection>
                                        <div className=" mx-2 my-2 claim-info-section">
                                            {refundProcessType === 'adjustmentModal' &&
                                                <div>
                                                    <h6>Adjustment Options</h6>
                                                    <div style={{ display: 'flex', marginTop: '6px' }}>
                                                        {adjustmentRadioOptions &&
                                                            adjustmentRadioOptions.map((value, index) => (
                                                                <div key={index} style={{ marginRight: '40px' }}>
                                                                    <Field
                                                                        component={RadioButton}
                                                                        name='adjustmentOptions'
                                                                        id={value.value}
                                                                        defaultValue={adjustmentRadioOptions[0].value}
                                                                        onSelect={(e) => { }}
                                                                        label={value.label}
                                                                    />
                                                                    <span>{showToolTip(value.value, value.tooltip)}</span>
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            }
                                            {(refundProcessType === 'adjustmentModal' || refundProcessType === 'adjustmentPTOveride') &&
                                                <div style={{ display: 'flex', justifyContent: "space-between", marginRight: '10px', marginTop: '10px' }}>
                                                    <p>Quantity Adjustment<span style={{ color: '#a30202' }}>&#42;</span>
                                                    </p>
                                                    <NumberInput
                                                        name='ammendedQuantity'
                                                        onChangeHandler={(value) => calcualteFunction(parseFloat(value) * selectedOrderDetails.orderDetails?.pricePerPallet)}
                                                    />
                                                </div>
                                            }
                                            {/* this is for refund tax, making use of same quantity number field */}
                                            {refundProcessType === 'refundTaxModal' &&
                                                <div style={{ display: 'flex', justifyContent: "space-between", marginRight: '10px', marginTop: '10px' }}>
                                                    <p>Refund Tax Amount<span style={{ color: '#a30202' }}>&#42;</span>
                                                    </p>
                                                    <NumberInput
                                                        name='taxAmount'
                                                        disabled={true}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </AdjustRefundSection>

                                    {(refundProcessType === 'adjustmentModal' || refundProcessType === 'adjustmentPTOveride') &&
                                        <SummarySection>
                                            <div className="mx-2 my-2 summary-section">
                                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(205px, 1fr))' }}>
                                                    <div className="summary-info">
                                                        <h6>Adjusted Seller Remittance</h6>
                                                        <div>
                                                            <p>Qty</p>
                                                            <p>{props.values.ammendedQuantity}</p>
                                                        </div>
                                                        <div>
                                                            <p>Base</p>
                                                            <p>${selectedOrderDetails.orderDetails?.pricePerPallet?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                        <div>
                                                            <p>Total Base</p>
                                                            <p>{summaryInfoValues && '$'}{refundProcessType === 'adjustmentPTOveride' ? '0' : summaryInfoValues?.productPrice?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                        <div>
                                                            <p>Total PT Fee</p>
                                                            <p>{summaryInfoValues && '$'}{refundProcessType === 'adjustmentPTOveride' ? '0' : summaryInfoValues?.sellerFee?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                        <div><p></p><p></p></div><div><p></p><p></p></div>
                                                        <hr />
                                                        <div>
                                                            <p>Total Adjusted Rem</p>
                                                            <p>{summaryInfoValues && '$'}{refundProcessType === 'adjustmentPTOveride' ? '0' : summaryInfoValues?.totalSellerPrice?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                    </div>
                                                    <div className="summary-info">
                                                        <h6>Adjusted Buyer Receivable</h6>
                                                        <div>
                                                            <p>Qty</p>
                                                            <p>{props.values.ammendedQuantity}</p>
                                                        </div>
                                                        <div>
                                                            <p>Base</p>
                                                            <p>${selectedOrderDetails.orderDetails?.pricePerPallet?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                        <div>
                                                            <p>Total Base</p>
                                                            <p>{summaryInfoValues && '$'}{summaryInfoValues?.productPrice?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                        <div>
                                                            <p>Total PT Fee</p>
                                                            <p>{summaryInfoValues && '$'}{summaryInfoValues?.buyerFee?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                        <div>
                                                            <p>Total Tax</p>
                                                            <p>{summaryInfoValues && '$'}{summaryInfoValues?.taxAmount?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                        <div>
                                                            <p>Payment Ent Fee</p>
                                                            <p>{summaryInfoValues && '$'}{summaryInfoValues?.stripeFee?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Total Adjusted Paya</p>
                                                            <p>{summaryInfoValues && '$'}{summaryInfoValues?.totalBuyerPrice?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SummarySection>
                                    }
                                </>

                                {(refundProcessType === 'adjustmentModal' || refundProcessType === 'adjustmentPTOveride') &&
                                    <div>
                                        <p style={{ margin: '10px 0px 7px 10px', fontWeight: 'bold' }}>
                                            {refundProcessType === 'adjustmentPTOveride' ?
                                                `REFUND TO BUYER: The adjustment will be taken from our PalletTrader account and REFUND the buyer $${summaryInfoValues ? summaryInfoValues?.totalBuyerPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}.`
                                                : props.values.adjustmentOptions === 'refundBuyer' ?
                                                    `REFUND TO BUYER: This adjustment will TAKE BACK funds from the seller and REFUND the buyer $${summaryInfoValues ? summaryInfoValues?.totalBuyerPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}.`
                                                    : props.values.adjustmentOptions === 'chargeBuyer' ?
                                                        `CHARGE THE BUYER: This adjustment will CHARGE the buyer and PAY the seller $${summaryInfoValues ? summaryInfoValues?.totalSellerPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}.`
                                                        : ''
                                            }
                                        </p>
                                    </div>
                                }

                                <div className="mx-2">
                                    <p className="mt-0" style={{ color: '#3d91c5' }}>Comments<span style={{ color: '#a30202' }}>&#42;</span>
                                        <span>{showToolTip("commentValidation", "Comment should have atleast 10 characters")}</span></p>
                                    <p>Comments will go to buyer and seller via Email</p>
                                    <TextArea name="comments" showErrorMessages={true} />
                                </div>

                                <SubmitButtonWrapper>
                                    <div className="submit-button-wrapper">
                                        <HOCButton
                                            type="app-green-button submitBtn"
                                            handleClick={() => {
                                                if (refundProcessType === 'refundTaxModal') adminRefundTaxInitiateFunction(props)
                                                else adminRefundInitiateFunction(props)
                                            }}
                                            disabled={((refundProcessType === 'adjustmentModal' || refundProcessType === 'adjustmentPTOveride') && (props.values.comments === '' || props.values.ammendedQuantity === '')) ||
                                                (refundProcessType === 'refundTaxModal' && props.values.comments === '')
                                            }
                                        >
                                            Submit
                                        </HOCButton>
                                    </div>
                                </SubmitButtonWrapper>
                            </Form>
                        </div>
                    );
                }}
            </Formik>
            <AlertModal
                isOpen={modal}
                toggle={() => setModal(!modal)}
                content={modalContent}
            />
        </>
    );
}

export default AdjustmentModal;
